import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "center-text" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loginText" }, "登录口", -1)
const _hoisted_3 = { class: "input-group captcha-group" }
const _hoisted_4 = ["src"]

import { ref, reactive } from 'vue'
import router from '../../router'
import { layer } from '@layui/layer-vue'
import {login,getCaptcha} from '../../api'
import { setToken,removeToken,setUserName } from '@/utils/auth'
import md5 from 'js-md5';

 


  // 响应式变量
  
export default /*#__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {

const user = reactive({
    userName: "",
    password: "",
    captcha:"",
    codeKey:""

})

  const captchaSrc=ref("")
const  reloadCaptcha=function () {
    getCaptcha().then((res: any) => {
        if (res!=""&&res.code == 0) {  
            captchaSrc.value=res.data
        }
    })
    
}

reloadCaptcha();



 
const submit2 = function () {
    removeToken();
    

    if(user.userName.length==0||user.password.length==0){ 
            layer.msg("账号或者密码不能为空", { icon : 2, time: 1000}) 
            return false;
        }

        if(user.captcha.length==0){ 
      layer.msg("请输入验证码", { icon : 2, time: 1000}) 
      return false;
  }


        user.codeKey=md5.md5(captchaSrc.value); 
        login(JSON.stringify(user)).then((res: any) => {
            if (res!=""&&res.code == 0) { 
                setUserName(user.userName);
                setToken(res.data);
                layer.msg("登录成功", { icon : 1, time: 1000}) 
                router.push({ path: '/' }) 
            }else{
              reloadCaptcha();

            }  
        })
 
};


return (_ctx: any,_cache: any) => {
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_panel = _resolveComponent("lay-panel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_lay_panel, null, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_lay_form, {
          model: user,
          pane: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_form_item, {
              label: "账户",
              prop: "userName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_input, {
                  modelValue: user.userName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.userName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_lay_form_item, {
              label: "密码",
              prop: "passWord"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_input, {
                  modelValue: user.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.password) = $event)),
                  type: "passWord"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_lay_form_item, {
              label: "验证码",
              prop: "passWord"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "captcha",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.captcha) = $event)),
                    placeholder: "请输入验证码"
                  }, null, 512), [
                    [_vModelText, user.captcha]
                  ]),
                  _createElementVNode("img", {
                    src: 'data:image/jpeg;base64,'+captchaSrc.value,
                    onClick: reloadCaptcha,
                    class: "captcha-img"
                  }, null, 8, _hoisted_4)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_lay_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_button, {
                  type: "primary",
                  onClick: submit2
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("提交")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    })
  ]))
}
}

})